import { atom } from 'recoil';

// Pin location type
export interface PinLocation {
    lat: number;
    lng: number;
}

// Drop pin mode state type
export interface DropPinModeState {
    isActive: boolean;
    step: 'positioning' | 'naming' | 'details' | null;
    pinLocation: PinLocation | null;
    searchName?: string | null;
    tempPlaceId?: string | null;
}

// Atom to track drop pin mode state
export const atom_dropPinMode = atom<DropPinModeState>({
    key: 'dropPinMode',
    default: {
        isActive: false,
        step: null,
        pinLocation: null,
    },
});
